/**
 * Defines types of Render
 *
 * @hidden
 * @deprecated
 */
export var RenderType;
(function (RenderType) {
    /** Defines RenderType as Toolbar */
    RenderType[RenderType["Toolbar"] = 0] = "Toolbar";
    /** Defines RenderType as Content */
    RenderType[RenderType["Content"] = 1] = "Content";
    /** Defines RenderType as Popup */
    RenderType[RenderType["Popup"] = 2] = "Popup";
    /** Defines RenderType as LinkToolbar */
    RenderType[RenderType["LinkToolbar"] = 3] = "LinkToolbar";
    /** Defines RenderType as TextToolbar */
    RenderType[RenderType["TextToolbar"] = 4] = "TextToolbar";
    /** Defines RenderType as ImageToolbar */
    RenderType[RenderType["ImageToolbar"] = 5] = "ImageToolbar";
    /** Defines RenderType as AudioToolbar */
    RenderType[RenderType["AudioToolbar"] = 6] = "AudioToolbar";
    /** Defines RenderType as AudioToolbar */
    RenderType[RenderType["VideoToolbar"] = 7] = "VideoToolbar";
    /** Defines RenderType as InlineToolbar */
    RenderType[RenderType["InlineToolbar"] = 8] = "InlineToolbar";
    /** Defines RenderType as TableToolbar */
    RenderType[RenderType["TableToolbar"] = 9] = "TableToolbar";
})(RenderType || (RenderType = {}));
